import { Mail, MapPin, Phone } from "lucide-react";
const contacts = [
  {
    icon: <Mail size={18} />,
    label: "Email",
    value: "rm45555@gmail.com",
    href: "mailto:rm45555@gmail.com",
  },
  {
    icon: <Phone size={18} />,
    label: "Phone",
    value: "+351 967 394 751",
    href: "tel:+351967394751",
  },
  {
    icon: <MapPin size={18} />,
    label: "Location",
    value: "Portugal",
  },
  {
    icon: <i className="devicon-github-original" />,
    label: "GitHub",
    value: "RicardoMartins07",
    href: "https://github.com/RicardoMartins07",
  },
];

export default contacts;
